import { tState } from "../components/RenderDevEditForm/RenderDevEditForm";

export const getDeep = (obj: any, path?: (string | number)[]) =>
   !obj || !path ? undefined : path.reduce((acc, k) => (acc == null ? acc : acc[k]), obj);

const from01ToBool = (value: string | number | boolean) =>
   value === 1 || value === "1" || value === true;

export const READ_MAP: Record<
   keyof tState,
   { path?: (string | number)[]; parse?: (value: any) => any }
> = {
   // lable: element.object.UIP_OPIS
   lable: { path: ["label"], parse: (value) => value ?? "" },

   // Search options
   seekingOut: {
      path: ["FormLoContent", "seeking_out_type"],
      parse: (value) => (value == null ? "1" : String(value)) as tState["seekingOut"],
   },
   seekingOutWithSearch: {
      path: ["FormLoContent", "seeking_out_with_search"],
      parse: from01ToBool,
   },
   advansedSearch: { path: ["FormLoContent", "advansed_search_list_id"], parse: from01ToBool },
   dedicatedSearchId: {
      path: ["FormLoContent", "dedicated_list_value"],
      parse: (value) => (value === "0" ? "" : value),
   },
   advansedSearchId: {
      path: ["FormLoContent", "advansed_search_list_id_string"],
      parse: (value) => (value === "0" ? "" : value),
   },

   // List settings
   dropdownIsEmptyOption: { path: ["object", "UIP_NUM4"], parse: from01ToBool },
   dropdownEmptyOptionLabel: { path: ["object", "UIP_TEKST3"], parse: (value) => value ?? "" },
   dropdownEmptyOptionValue: { path: ["object", "UIP_TEKST4"], parse: (value) => value ?? "" },

   // Checkboxes
   Subfolder: { path: ["object", "UIP_TEKST1"], parse: from01ToBool },
   Required: { path: ["obow"], parse: from01ToBool },
   Hidden: { path: ["hidden"], parse: from01ToBool },
   hiddenOnPrint: { path: ["object", "hidden_on_print"], parse: from01ToBool },
   Transparency: { path: ["object", "UIP_TRANSPARENCY"], parse: from01ToBool },
   toggleTag: { path: ["toggleTag"], parse: from01ToBool },
   Editable: { path: ["object", "UIP_EDYT"], parse: from01ToBool },
   useAsTag: { path: ["UTB_TOGGLE_TAG"], parse: from01ToBool },

   barcode_support: { path: ["object", "UIP_BARCODE_SUPPORT"], parse: from01ToBool },

   // Position
   position: { path: ["FormLoContent", "page_position"], parse: (value) => value ?? "left" },

   // Precision
   precision: { path: ["precision"], parse: (value) => String(value ?? "") },
};
